import { Divider } from "@atoms"

export default function SelectListGroupDivider() {
    return <Divider contrast="medium" />
}
